<template>

    <div class="buttons-actions">
        <ul v-if="editAlert==null">
            <li class="has-text-centered is-position-relative">
                <b-tooltip  v-if="isActive && dataListing.length>0 && ind === 0" class="compare-to-peers-tooltip" label="Compare to Peers" always>
                </b-tooltip>
                <router-link :to="{name:'Comparison',params:{id:ISIN, text: fund_data ? convertURL(getShort(fund_data.FundBasicsName)) : 'default'}}" class="btn-1" v-tooltip="'Compare to Peers'"><img src="/img/noun_balance_3014443.svg" @error="(e) => e.target.src='/img/noun_balance_3014443.svg'">
                </router-link>
            </li>
            <li v-if="!isHidden">
                <router-link :to="{name:'Referral',params:{id:ISIN, text: fund_data ? convertURL(getShort(fund_data.FundBasicsName)) : 'default'}}" class="btn-1" v-tooltip="`Invest | ${checkNumberOfPlatforms} available`">INV</router-link>
            </li>

            <li v-if="isLogin && isAlert">
                 <a v-if="selectedWatchlistID" @click="alertFundFromWatchlistPage" class="btn-3" v-tooltip="'Add Alerts'"><img src="/img/bell.svg" @error="(e) => e.target.src='/img/bell.svg'"></a>
                 <a v-else @click="getAlertOptions()" class="btn-3" v-tooltip="'Add Alerts'"><img src="/img/bell.svg" @error="(e) => e.target.src='/img/bell.svg'"></a>
            </li>

            <li v-if="isDeleteFund && isLogin">
                <a @click="deleteFund" class="btn-4" v-tooltip="'Delete Fund'">
                    <b-icon class="white-text is-size-5" icon="close" size="is-small"></b-icon>
                </a>
            </li>

            <li v-if="!isDeleteFund && isLogin">
                <a v-if="selectedWatchlistID" @click="addFundFromWatchlistPage"  class="btn-4 " v-tooltip="'Add to Watchlists'"><img src="/img/noun_Eye_2037671.svg" @error="(e) => e.target.src='/img/noun_Eye_2037671.svg'"></a>
                <a v-else @click="checkAuthenticatedWatchlist()"  class="btn-4 " v-tooltip="'Add to Watchlists'"><img src="/img/noun_Eye_2037671.svg" @error="(e) => e.target.src='/img/noun_Eye_2037671.svg'"></a>
            </li>
        </ul>
        <div class="model alert-modal is-hidden-mobile" v-if="AlertModal">
            <div class="model-head">
              <div class="alert-head">ALERT <img src="/img/Alerts.png"></div>
             <a class="model-close" v-on:click="hideModal()"><img src="/img/close.png" /></a>
            </div>
            <div class="model-body center">
                <form ref="alertform" @submit="update_alerts">
                   <h1 class="alert-title">{{fund_data.FundBasicsName}}</h1>
                <ValidationObserver ref="observer" v-slot="{ invalid, validated }">
                    <b-message v-if="invalid && validated" type="is-danger" aria-close-label="Close message">
                        Please select a limit for your alert
                    </b-message>

                   <table class="tableclear">
                        <tr>
                            <th class="font-weight-400">Alert me when...</th>
                            <th></th>
                            <th><a v-on:click="clearallalerts()" class="btn btn-clear is-white-space-nowrap">CLEAR ALL</a></th>
                        </tr>

                        <tr v-for="(item, index) in getOptionData" :key="index">
                            <th class="font-weight-400"><span>{{item.name}}</span></th>
                            <td style="border-bottom: 0 !important" v-if="item.type_input==='select'">
                                <span class="select font-large">
                                    <select :disabled="item.disabled" v-model="getOptionData[index].current_option">
                                        <option :value="null">No alerts set</option>
                                        <template v-for="(option, optionIndex) in getOptionData[index].options">
                                            <option :key="optionIndex" :value="option">{{option=='greater_than' ? 'Greater than' : 'Less than'}}</option>
                                        </template>
                                    </select>
                               </span>
                            </td>
                            <td class="vertical-align-middle" style="border-bottom: 0 !important">
                                <span v-if="item.type_input==='select'">
                                    <ValidationProvider :rules="getOptionData[index].current_option?'required':''" v-slot="{ errors }">
                                    <b-field
                                        :type="{ 'is-danger': errors[0] }"
                                    >
                                        <b-select class="select-alert" :disabled="getOptionData[index].current_option?false:true" v-model="getOptionData[index].current_threshold">
                                            <template v-for="(i, index) in item.thresholds">
                                                <option :key="index" :value="i">{{getAlertThresholdsPrefix(item.name)+i+' '+item.unit}}</option>
                                            </template>
                                        </b-select>
                                    </b-field>
                                    </ValidationProvider>
                                </span>
                                <label class="switch is-rounded" v-else-if="item.type_input==='checkbox'">
                                    <b-field>
                                        <b-switch
                                        :true-value="true" :false-value="false"
                                        :value="Boolean(getOptionData[index].current_option)"
                                        @input="(value) => {
                                            getOptionData[index].current_option = value;
                                            getOptionData[index].current_threshold = value;
                                        }"></b-switch>
                                    </b-field>
                                </label>
                            </td>
                            <td class="vertical-align-middle" style="border-bottom: 0 !important">
                                <a class="clear-btn is-size-7" @click="getOptionData[index].current_option=null, getOptionData[index].current_threshold=null">Clear</a>
                            </td>
                        </tr>
                   </table>
                </ValidationObserver>
                <button class="alertsave button is-primary mt-2">DONE</button>
                </form>
            </div>

        </div>

        <b-modal can-cancel="outside" v-model="AlertModal" class="alert-modal is-hidden-tablet" :full-screen="true">
            <div class="modal-card">
                <header class="modal-card-head p-b-40 border-bottom">
                    <a class="btn-close" @click="AlertModal=!AlertModal">
                        <b-icon  icon="close" size="is-medium" ></b-icon>
                    </a>
                </header>
                <section class="modal-card-body p-t-0 text-align-left">
                    <div class="alert-head p-2 text-align-center is-size-6">
                        Alert
                        <img class="vertical-align-middle" src="/img/Alerts.png">
                    </div>
                    <div class="card-content">
                        <div class="is-flex">
                            <h2 class="has-text-weight-bold is-size-4-tablet is-size-5-mobile is-white-space-normal">
                                {{fund_data.FundBasicsName}}
                            </h2>
                            <div class="is-white-space-nowrap is-align-self-center p-l-10">
                                <a v-on:click="clearallalerts()" class="btn btn-clear">CLEAR ALL</a>
                            </div>
                        </div>
                        <p class="pt-3 is-size-6">Alert me when...</p>
                        <div v-for="(item, index) in getOptionData" :key="index">
                            <p class="pt-5 is-size-6">{{getOptionData[index].name}}</p>
                            <hr class="hr-gray m-t-10 m-b-20">
                            <div class="is-flex">
                                <template v-if="getOptionData[index].type_input==='select'">
                                    <span class="select">
                                    <select :disabled="getOptionData[index].disabled" v-model="getOptionData[index].current_option">
                                        <option :value="null">No alerts set</option>
                                        <template v-for="(option, optionIndex) in getOptionData[index].options">
                                            <option :key="optionIndex" :value="option">{{option=='greater_than' ? 'Greater than' : 'Less than'}}</option>
                                        </template>
                                    </select>
                                    </span>
                                    <span class="select m-l-10">
                                        <b-select class="select-alert" :disabled="getOptionData[index].current_option?false:true" v-model="getOptionData[index].current_threshold">
                                            <template v-for="(threshold, indexThreshold) in getOptionData[index].thresholds">
                                                <option :key="indexThreshold" :value="threshold">{{getAlertThresholdsPrefix(item.name)+threshold+' '+getOptionData[index].unit}}</option>
                                            </template>
                                        </b-select>
                                    </span>
                                </template>
                                <label class="switch is-rounded" v-else>
                                    <b-field>
                                        <b-switch
                                        :true-value="true" :false-value="false"
                                        :value="Boolean(getOptionData[index].current_option)"
                                        @input="(value) => {
                                            getOptionData[index].current_option = value;
                                            getOptionData[index].current_threshold = value;
                                        }"></b-switch>
                                    </b-field>
                                </label>
                                <span class="is-align-self-center flex-grow text-align-right">
                                    <a class="clear-btn is-size- expand-collapse" @click="getOptionData[index].current_option=null, getOptionData[index].current_threshold=null">Clear</a>
                                </span>
                            </div>
                        </div>
                        <div class="mt-2">
                            <a class="button is-primary is-uppercase" @click="update_alerts">Done</a>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>

        <b-modal has-modal-card 
            @after-enter="renderExistingWatchlist"
            :full-screen="isMobile()?true:false" 
            can-cancel="outside" 
            v-model="showModal" 
            :width="640">
            <div v-if="!isMobile()" class="modal-card" style="text-align: -webkit-center;">
            <header class="modal-card-head">
                <div class="model-icon icon-watchlist">
                    <img src="/img/noun_Eye_2037671.svg">
                </div>
                <button
                    type="button"
                    class="delete"
                    @click="showModal=!showModal"
                />
            </header>
            <section class="modal-card-body">
                <div class="card-content">
                    <div class="has-text-weight-bold is-size-4-tablet mb-5">Add funds to selected Watchlist</div>
                    <div v-for="(i, index) in myWatchlist" :key="index" class="columns is-flex px-7 pt-0 pb-0">
                        <div class="column"><span class="is-size-6-tablet">{{i.name}}</span></div>
                        <b-checkbox :id="'watchlist-'+index" :value="tolist[index]" @input="addToList($event, index, i)"></b-checkbox>
                    </div>
                    <div class="columns px-7 m-t-10">
                        <div class="column pr-0 pb-0">
                            <a @click="isModalCreatedWatchlist=!isModalCreatedWatchlist, showModal=!showModal" class="button is-secundary is-size-7">Create New</a>
                        </div>
                        <div class="column pl-0 pb-0">
                            <button @click="addWatchlist_add()" class="button is-primary is-size-7">Add</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div v-else class="modal-card h-100">
            <header class="modal-card-head p-b-40 border-bottom">
                <a class="btn-close" @click="showModal=!showModal">
                    <b-icon  icon="close" size="is-medium" ></b-icon>
                </a>
            </header>
            <section class="modal-card-body pt-0">
                <div class="watchlist-head p-2 text-align-center is-uppercase mb-5">
                    Add To Watchlist
                    <img class="pl-5" src="/img/Watchlist.png">
                </div>
                <div class="card-content">
                    <div class="has-text-weight-bold is-size-4-tablet is-size-6-mobile mb-6">Add funds to selected Watchlist</div>
                    <div v-for="(i, index) in myWatchlist" :key="index" class="columns is-flex pt-0 pb-0">
                        <div class="column is-2-mobile">
                        <b-checkbox class="checkbox-watchlist" :value="tolist[index]" @input="addToList($event, index, i)"></b-checkbox>
                        </div>
                        <div class="column pl-0 is-align-self-center"><span>{{i.name}}</span></div>
                    </div>
                    <div class="columns is-flex px-5">
                        <div class="column pr-0 text-align-center">
                            <a @click="addWatchlist_add()" class="button is-primary is-size-7">Add</a>
                        </div>
                        <div class="column pl-0">
                            <a @click="isModalCreatedWatchlist=!isModalCreatedWatchlist, showModal=!showModal" class="button is-secundary is-size-7">Create New</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        </b-modal>
        <b-modal has-modal-card 
            :full-screen="isMobile()?true:false" 
            can-cancel="outside" 
            v-model="isModalCreatedWatchlist" 
            @after-leave="showModal=!showModal"
            :width="640">
            <watchlist-modal :fundId="fund_data.fund_id"></watchlist-modal>
        </b-modal>
    </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import compositeMixin from "@/mixins/compositeMixin";
import axios from "axios";
import WatchlistModal from '@/components/WatchlistModal.vue';
import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';

setInteractionMode('eager')

export default {
    components: { 
        WatchlistModal,
        ValidationProvider,
        ValidationObserver 
    },
    name: 'Buttons',
    props: {
        ISIN:String,
        fundId:String,
        fund_data:Object,
        isHidden:Boolean,
        selectedWatchlistID: Number,
        isLogin: {
            type: Boolean,
            default: true
        },
        editAlert: {
            type: Boolean,
            default: null
        },
        isDeleteFund: {
            type: Boolean,
            default: false
        },
        ind: Number,
        isAlert: {
            type: Boolean,
            default: true
        }
    },
    mixins:[commonMixin, compositeMixin],
    data(){
        return{
            isModalCreatedWatchlist: false,
            AlertModal:false,
            showModal: false,
            newlistname : '',
            myWatchlist : [],
            tolist : [],
            getOptionData: [],
            isActive: true
        }
     },
    created() {
      window.addEventListener('scroll', this.windowScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
    },
    watch: {
        editAlert:function(val) {
            if (val) {
                this.getAlertOptions();
            }
        },
        AlertModal:function(value) {
            this.$store.commit("messages/SET_MODAL_ALERT", value)
        },
        showModal:function(value) {
            this.$store.commit("messages/SET_MODAL_WATCHLIST_ADD_FUND", value)
        },
        isModalCreatedWatchlist:function(value) {
            this.$store.commit("messages/SET_MODAL_WATCHLIST_CREATE_NEW", value)
        }
    },
    computed: {
        checkNumberOfPlatforms() {
            if(this.fund_data) {
                if(this.fund_data.numberOfPlatforms > 1) return `${this.fund_data.numberOfPlatforms+' platforms'}`
                else return `${this.fund_data.numberOfPlatforms+' platform'}`;                
            }
            return 0;
        },
        dataListing(){
            if(this.$store.state.search.searchData.data) return this.$store.state.search.searchData.data
            else return [];
        }
    },
    methods: {
        getAlertThresholdsPrefix(type) {
            let result = "";

            switch (type) {
                case "Net Assets":
                    result = "£"
                    break;
                default:
                    break;
            }   

            return result
        },
        backToPageLogin(limit) {
            this.$store.commit("auth/SET_HITTING_LIMIT", limit)
            this.$router.push('/login/max-5')
        },
        addToList (e, index, item) {
            if (!item.disabled) {
                if (e) {
                    this.tolist[index] = item.id
                } else {
                    this.tolist[index] = null
                }
            } else {
                if (e) {
                    return this.$toast.error('Watchlist already full (20 funds max)')
                }
            }
        },
        checkAuthenticatedWatchlist() {
            if(this.$store.state.auth.authenticated) {
                this.showModal=!this.showModal;
            } else {
                this.backToPageLogin('watchlist')
            }
        },
        addFundFromWatchlistPage() {
            if(this.$store.state.auth.authenticated) {
               axios.post(`/watchlist/fund`,{
                fund_id: this.fund_data.fund_id,
                watchlist_ids: [this.selectedWatchlistID],
                isin: this.ISIN
                }).then(res => {
                    if(res.status===200) {
                        this.$toast.success('Fund added to Watchlist successfully!')
                    }
                }).catch(err => {
                    this.$toast.error(err.response.data.message)
                });
            }
            else {
                this.backToPageLogin('watchlist')
            }
        },
        alertFundFromWatchlistPage () {
            this.$router.push({name:"Watchlist", params: {watchlistID: this.selectedWatchlistID}})
        },
        getAlertOptions() {
            if(this.$store.state.auth.authenticated) {
                this.$store.commit("messages/SET_MODAL_ALERT", true)
                axios.get("/alerts/option", {
                    params: {
                        fund_id: this.fund_data.fund_id
                    }
                })
                .then( async res => {
                    this.AlertModal=!this.AlertModal;
                    this.getOptionData = res.data.data;
                })
                .catch(error => {
                    this.$toast.error(error.response.data.message)
                    
                })
            }
            else {
                this.backToPageLogin('alert')
            }
        },
        
        deleteFund() {
            this.$buefy.dialog.confirm({
                type: 'is-danger',
                hasIcon: true,
                message: 'Delete fund?',
                onConfirm: () => {
                    axios.delete("/watchlist/fund", 
                    {
                        params: {
                            watchlist_id: this.$store.state.watchlist.currentWatchlist.id, 
                            fund_id: this.fund_data.fund_id
                        }
                    }).then(res => {
                        if(res.status === 200) this.$emit("getFundByIdWatchlist")
                    })
                }
            })
        },
        hideModal : function (){
            this.showModal = false;
            this.AlertModal = false;
            this.$bus.$emit("closeAlertModal", false)
        },
        async load_list() {
            await this.$store.dispatch("watchlist/getMyWatchlists")
            this.myWatchlist = this.$store.state.watchlist.myWatchlists;
            this.tolist = [];
        },
        update_alerts(e) {
            e.preventDefault();
            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    return
                }
                this.postOptionsAlert();
                
            })
        },
        postOptionsAlert() {
            const postOption = []
            this.getOptionData.forEach(el => {
                let item = {
                    type_id: el.type_id,
                    current_option: el.current_option,
                    current_threshold: el.current_threshold
                }
                postOption.push(item)
            })
            let invalid = true
            postOption.forEach(el => {
                if (el.current_threshold) {
                    invalid = false
                }
            })
            if (invalid) {
                this.$toast.error('Please choose a alert type.')
            } else {
                axios.post("/alerts/option", {
                    fund_id: this.fund_data.fund_id,
                    options: [...postOption]
                }).then(res => {
                    if(res.status===200) {
                        this.$bus.$emit('newAlertAdded', true)
                        this.$toast.success("New alert added")
                    }
                    this.hideModal();
                    
                }).catch(() => {
                    this.$toast.error('You can only create 10 alerts')
                    this.hideModal();
                })
            }
            
        },

        clearallalerts : function(){
            this.getOptionData.forEach(el => {
                el.current_option = null
                el.current_threshold = null
            })
        },
        
        async addWatchlist_add() {
            let watchlistIds = this.tolist.filter(item => !!item)
            if(watchlistIds.length > 0) {
                axios.post(`/watchlist/fund`,{
                fund_id: this.fund_data.fund_id,
                watchlist_ids: watchlistIds,
                isin: this.ISIN
                }).then(res => {
                     this.tolist = [];
                    if(res.status===200) {
                        this.$toast.success('Fund added to Watchlist successfully!')
                        this.showModal = !this.showModal;
                    }
                }).catch(err => {
                    this.tolist = [];
                    this.$toast.error(err.response.data.message)
                });
            }
            else {
                this.$toast.error('Please select a valid Watchlist to add the fund in.')
                
            }
            
        },
        renderExistingWatchlist() {
            this.load_list();
        },
        windowScroll() {
            if (window.scrollY) {
                if (window.innerWidth < 768) {
                    var self = this;
                    setTimeout(function(){
                        self.isActive=false;    
                    },5000)
                } else {
                    this.isActive=false;
                } 
            }
            
        },
    }
}
</script>

<style scoped>
.error{color:red; font-size:14px; display:block}
.model{
    background-color:#FFF;
    position: fixed;
    top:25%;
    left:50%;
    width: 95%;
    max-width: 400px;
    margin-left: -200px;
    z-index:300;
    color:#333;
    -webkit-box-shadow: 5px 5px 50px 1px #4F4F4F;
    box-shadow: 5px 5px 50px 1px #4F4F4F;
}

.model-icon{
   background-color:#ccc;
   padding:10px;
}

.model-head .model-close img{
    height:50px;
    float:right;

}
.model-body{
    padding:25px;
}
.model-body h1{
    font-weight:900;
    margin:50px;


}
.center{
text-align:center;
}
.portlist {
    max-height:300px;
    overflow-x:auto;
}
.portlist div{
    margin-bottom:20px;
    display:block !important;

}
.portlist div input{
    margin-left:30px;
}

/*------alert model---------*/
.tableclear,
.tableclear tr,
.tableclear tr td{
    box-shadow: none;
    border:none;
}
.tableclear tr th
{
 padding:20px;
 text-align:center;
}
.tableclear tr td{
    padding:10px;
}

.alert-modal .model-body h1{
    font-weight:900;
    margin-top:0px;
}

.alert-modal select option{
    color:#111 !important;
}
/*------------*/

@media (max-width: 768px) {
    .model{
        max-width: 95%;
        left: 2.5%;
        margin-left: 0;
    }

    .alert-head{
        background-color:#ED5255;
        color:#FFF;
        margin-left: -20px;
        margin-right: -20px;
    }
}

@media (min-width: 768px) {
    .alert-modal {
        top:2%;
        left:30%;
        max-width: 60% !important;
    }
    
    .alert-head{
        background-color:#ED5255;
        color:#FFF;
        padding:15px 25px;
        display: inline-block;
    }
}
</style>
